/**
 * Interceptor para peticiones salientes
 * @param {Object} config - Configuración de Axios
 * @returns {Object} - Configuración modificada
 */
export function onRequestSuccess (config) {
  // Agregar token de autenticación
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  // Agregar headers personalizados
  config.headers['X-Request-ID'] = crypto.randomUUID()

  // Logging en desarrollo
  if (import.meta.env.DEV) {
    console.log('API Request:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      params: config.params,
    })
  }

  return config
}

/**
 * Interceptor para errores en peticiones
 * @param {Object} error - Error antes de enviar la petición
 * @returns {Promise} - Promesa rechazada
 */
export function onRequestError (error) {
  if (import.meta.env.DEV) {
    console.error('Request Setup Error:', error)
  }
  return Promise.reject(error)
}
